export default __webpack_public_path__ + "static/media/View_of_valley_between_Malwa_and_Mandu_plateaus.aa48ef5f.jpg";